import React from 'react';
import { useTranslation } from 'react-i18next';

interface InactivityWarningModalProps {
  countdown: number;
  onStayLoggedIn: () => void;
  onLogout: () => void;
}

const InactivityWarningModal: React.FC<InactivityWarningModalProps> = ({
  countdown,
  onStayLoggedIn,
  onLogout,
}) => {
  const { t } = useTranslation();

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-60 z-50 flex justify-center items-center p-4 transition-opacity duration-300 ease-in-out"
      aria-modal="true"
      role="dialog"
    >
      <div className="bg-brand-surface dark:bg-dark-surface rounded-lg shadow-xl w-full max-w-md text-center p-8">
        <h2 className="text-2xl font-bold text-brand-text-primary dark:text-dark-text-primary mb-2">
          {t('inactivity.title')}
        </h2>
        <p className="text-brand-text-secondary dark:text-dark-text-secondary mb-6">
          {t('inactivity.description')}
        </p>

        <div className="my-6">
          <p className="text-lg text-brand-text-secondary dark:text-dark-text-secondary">
            {t('inactivity.timeRemaining')}
          </p>
          <p className="text-5xl font-bold text-brand-danger">{countdown}</p>
          <p className="text-lg text-brand-text-secondary dark:text-dark-text-secondary">{t('common.seconds')}</p>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={onLogout}
            className="w-full sm:w-auto px-6 py-3 bg-gray-200 hover:bg-gray-300 text-gray-800 font-bold rounded-lg transition-colors"
          >
            {t('auth.logout')}
          </button>
          <button
            onClick={onStayLoggedIn}
            className="w-full sm:w-auto px-6 py-3 bg-brand-primary hover:bg-brand-primary-dark text-white font-bold rounded-lg transition-colors"
          >
            {t('auth.stayLoggedIn')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default InactivityWarningModal;
